<script setup lang="ts">
import ArticleSection from "./ArticleSection.vue";

const props = defineProps<{
  label: string;
  list: string[];
}>();
</script>

<template>
  <ArticleSection :label="props.label">
    <ul class="article-content__group-list article-content__group-list--narrow">
      <li
        v-for="(item, index) in props.list"
        :key="index"
        class="article-content__group-list-item article-content__group-list-item--square article-content__text article-content__text--light"
      >
        {{ item }}
      </li>
    </ul>
  </ArticleSection>
</template>
